<template>
    <div>
        <v-text-field label="共通卸コード"
                      v-bind:value="value"
                      v-on:input="(x) => $emit('input', x)"
                      @blur="onBlur"
                      @keydown.enter="onEnter"
                      clearable
                      maxlength="9">
            <template v-slot:append>
                <span class="mx-2 my-code-name" v-if="selected_item != null">{{ selected_item.wholesale_name }}</span>
                <v-btn icon color="primary darken-3" style="text-align:center;" small
                       v-on:click="onClick">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

        </v-text-field>

        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-card-title class="headline">卸一覧</v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field label="卸名(あいまい)" v-model="search.wholesale_name" clearable></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field label="卸コード(あいまい)" v-model="search.medi_code" clearable></v-text-field>
                            </v-col>
                        </v-row>
                        
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <span>
                                    対象件数 {{ wholesale_list.length }}件
                                </span>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="onSearch">検索</v-btn>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="dialog = false">閉じる</v-btn>
                            </v-col>
                        </v-row>

                        <v-simple-table dense height="500px">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" width="1px;"></th>
                                        <th class="text-left">共通卸コード</th>
                                        <th class="text-left">卸名</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in wholesale_list" v-bind:key="index">
                                        <td><v-btn class="mx-2" color="primary darken-3" dark @click="onSelectRow(item)">選択</v-btn></td>
                                        <td>{{ item.medi_code }} </td>
                                        <td>{{ item.wholesale_name }}</td>
                                    </tr>
                                  
                                </tbody>
                            </template>

                        </v-simple-table>

                    </v-container>
                    
                </v-card-text>

            </v-card>

        </v-dialog>
    </div>

</template>

<script>
    import Vue from 'vue'
    import MyAxios from './MyAxios.vue'
    Vue.mixin(MyAxios);

    export default {
        props: ['value'],
        watch: {
            value: function (val) {

                if (val.length == 9) {
                    this.getProductItem();
                } else {
                    this.selected_item = null;
                }
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                if (this.value.length == 9) {
                    this.getProductItem();
                }
                
            })
        },
        data: () => ({
            dialog: false,
            search: {
                wholesale_name: "",
                medi_code: ""
            },
            wholesale_list: [],
            selected_item: null,
        }),
        methods: {
            onClick() {
                this.dialog = !this.dialog;
            },
            onSelectRow(item) {
                this.dialog = false;
                this.selected_item = item;
                this.$emit('input', item.medi_code);
            },
            async onEnter(e) {
                if (e.keyCode !== 13) return;

                this.value = this.value.trim();
                await this.getProductItem();
            },
            async onBlur() {
                this.value = this.value.trim();
                await this.getProductItem();
            },
            async getProductItem() {
                this.search.wholesale_name = "";
                this.search.medi_code = "";
                this.selected_item = null;
                await this.onSearch();
                for (var i in this.wholesale_list) {
                    var item = this.wholesale_list[i];
                    if (item.medi_code == this.value) {
                        this.selected_item = item;
                        this.$emit('input', item.medi_code);
                        break;
                    }
                }
            },
            async onSearch() {
                try {
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.search));

                    let res = await this.axios_post('/api/CommonComponents/WholesaleSearch', params);
                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    this.wholesale_list = res.data.wholesale_list;

                } catch (err) {
                    this.msg_error_dialog(err);
                }
            }

        }
    }
</script>

<style>
    .my-code-name {
        padding: 6px 0 8px;
    }
</style>
